import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { ApplicationApiService } from 'src/app/shared/services/application-api.service';

import { WhatsappCreateModel } from 'src/app/shared/components/send-to-wa/send-to-wa.model';
import { ResponsePagination } from 'src/app/shared/utils';
import { TaskStatusService } from 'src/app/shared/services/task-status.service';

const URL_BASE = '/api/whatsapp/';

@Injectable({providedIn: 'root'})
export class WAApiService extends ApplicationApiService {

  constructor(
    protected injector: Injector,
    protected taskStatusService: TaskStatusService
  ) {
    super(injector);
  }

  public getSessions(): Observable<any[]> {
    return this.http.get<ResponsePagination<any[]>>(`${URL_BASE}session/`, {params: {active: 'true'}}).pipe(
      map(res => res.results)
    );
  }

  public enviar(data: WhatsappCreateModel): Observable<any[]> {
    return this.http.post<any[]>(`${URL_BASE}send-message/`, data).pipe(
      tap(() => {
        // Ativa verificação de status da tarefa
        this.taskStatusService.autoStopPolling = false;
        this.taskStatusService.notifyNewTaskSent();
        // habilita o auto stop polling após 10 segundos
        setTimeout(() => {
          this.taskStatusService.autoStopPolling = true;
        }, 10000);
      }),
      map(res => res)
    );
  }
}
